jQuery( document )
  .ready( function ( $ ) {
    isSmallMobile = {
      any: function ( ) {
        return $( window )
          .width( ) < 767;
      },
    };
    // *************************************************************************************************
    //    Mobile Footer Menus
    // *************************************************************************************************
    if ( $( window )
      .width( ) <= 768 ) {
      $( '.linkWrapper__widgets .widget' )
        .on( 'click', function ( ) {
          $( this )
            .toggleClass( 'active' )
            .siblings( )
            .removeClass( 'active' );
          $( this )
            .find( ' > div' )
            .slideToggle( )
            .parent( )
            .siblings( )
            .find( ' > div' )
            .slideUp( );
        } );
    }
    // *************************************************************************************************
    //	Homepage Scripts
    // *************************************************************************************************
    if ( document.body.classList.contains( 'home' ) ) {
      // *********************************************************************************************
      //	Scroll Reveal
      // *********************************************************************************************
      $( window )
        .bind( "load", function ( ) {
          //grab all elements that have the .ux-loading-item class
          var uxElements = $( '.ux-loading-item' );
          //run through the uxElements object array
          if ( uxElements ) {
            //run through the uxElements object array
            uxElements.each( function ( index ) {
              //make instances of each one - this
              var Element = $( this );
              // run a time out and add class of active and multiply the delay times the position it is in the object
              setTimeout( function ( ) {
                Element.addClass( 'active' );
              }, 500 * index );
            } );
          }
        } );
      var sr_elements = $(
        '.fly-in-bottom, .fly-in-left, .fly-in-right, .fly-in-top' );
      // if there are sr elements let's do them
      if ( sr_elements ) {
        window.sr = ScrollReveal( {
          duration: 750,
          scale: 1,
          origin: 'bottom',
          distance: '100px',
          easing: 'ease'
        } );
        // CTA Section
        sr.reveal( '.ctaSection .ctaWrap', 75 );
        // Reviews Section Right
        sr.reveal( '.reviewSection .reviews__reviewsWrapper', 75 );
        // Features Section
        sr.reveal( '.featuredSection > .container-wide', 75 );
        // Map Section
        sr.reveal( '.mapSection .mapWrapper__directions', 75 );
        // Seo Section
        sr.reveal( '.seoSection .seoSection__container', 75 );
      }
      // *********************************************************************************************
      //	Hero Algolia focus on search click
      // *********************************************************************************************
      $( '.algoliaRow__icon' )
        .click( function ( ) {
          $( '.twitter-typeahead #alg-search' )
            .focus( );
        } );
      // End - Hero Algolia Click
      // *********************************************************************************************
      //	Review Section Script
      // *********************************************************************************************
      // var reviews = new Swiper('.reviewSection .swiper-container', {
      // 	speed: 300,
      // 	slidesPerGroup: 1,
      // 	slidesPerView: 1,
      // 	watchOverflow: true,
      // 	lazy: {
      // 		enabled: true,
      // 	},
      // 	navigation: {
      // 		nextEl: '.reviewSection .swiper-button-next.reviews',
      // 		prevEl: '.reviewSection .swiper-button-prev.reviews',
      // 	},
      // });
      // // End - Review Row Section
      // *********************************************************************************************
      //	Model Section Script
      // *********************************************************************************************
      var featured_slider = new Swiper( '.featuredCarousel', {
        speed: 300,
        spaceBetween: 30,
        watchOverflow: true,
        navigation: {
          nextEl: '.featuredSection .swiper-button-next.featured',
          prevEl: '.featuredSection .swiper-button-prev.featured',
        },
        slidesPerGroup: 3,
        slidesPerView: 3,
        breakpoints: {
          1024: {
            slidesPerGroup: 2,
            slidesPerView: 2,
          },
          767: {
            slidesPerGroup: 1,
            slidesPerView: 1,
          },
        },
        preloadImages: false,
        lazy: true,
      } );
      // Lazyload images
      setTimeout( function ( ) {
        $( '.featuredSection .featuredItem__image img' )
          .each( function ( ) {
            $( this )
              .attr( 'src', $( this )
                .attr( 'data-original' ) );
          } );
      }, 3000 );
    }
  } );
